import { cn } from "@/lib/utils";
import logoUrl from "@/assets/brand/tinticloud-logo.png";
import miraUrl from "@/assets/brand/tinticloud-mira.png";

// Marca oficial TintiCloud. Fonte da verdade: /img/logo.png e /img/mira-v2.png
// na raiz do projeto; os arquivos em assets/brand são apenas derivados técnicos
// (margem transparente recortada e redimensionados, sem alterar proporção/cor).
// O texto "CLOUD" do logo é claro: pensado para o tema escuro da aplicação.

// Símbolo compacto (mira) — sidebar recolhida, 404 e espaços pequenos.
export const TintiMark = ({ className }) => (
  <img src={miraUrl} alt="TintiCloud" draggable={false} className={cn("h-8 w-8 select-none object-contain", className)} />
);

// Logo completo. `collapsed` mantém a API antiga: mostra só o símbolo.
export const TintiLogo = ({ collapsed = false, className }) => (
  collapsed
    ? <TintiMark className={className} />
    : <img src={logoUrl} alt="TintiCloud" draggable={false} className={cn("h-8 w-auto max-w-full select-none object-contain", className)} />
);
